import types from './types';
import API from '../../lib/api';
import WS from '../../lib/websocket';
import {toast} from 'react-toastify';
import {requestForToken} from '../../lib/firebase';
import ModalsLib from '../../lib/modals';
import globalTypes from '../types';
import getBrowserFingerprint from 'get-browser-fingerprint';
import Promotions from '../../utils/promotions';

export const createFacebookProfile = link => async dispatch => {
    dispatch({
        type: types.facebook.toggle
    });

    const response = await API.call({
        path: '/facebook_new/create',
        body: {
            link
        }
    });

    dispatch({
        type: types.facebook.toggle
    });

    if(!response.success) {
        toast.dismiss();
        toast.error(response.error);
    } else {
        dispatch({
            type: types.facebook.update,
            payload: response.profile
        });
    }
}

export const redeemFacebookBonus = () => async dispatch => {
    dispatch({
        type: types.facebook.toggle
    });

    const response = await API.call({
        path: '/facebook_new/redeem'
    });

    dispatch({
        type: types.facebook.toggle
    });

    if(!response.success) {
        toast.dismiss();
        toast.error(response.error);
    } else {
        dispatch({
            type: types.facebook.update,
            payload: response.data.profile
        });

        dispatch({
            type: types.pending_voucher,
            payload: response.data.pending_voucher
        });

        dispatch({
            type: types.balance,
            payload: response.data.balance
        });

        toast.dismiss();
        toast.success(response.message);
    }
}

export const setGame = game => {
    return {
        type: types.game,
        payload: game
    }
}

export const getKYCVerification = () => async dispatch => {
    const response = await API.call({
        path: '/kyc/verification'
    });

    if(response.success) {
        dispatch({
            type: types.kyc_profile.verification,
            payload: response.verification
        });
    } else {
        toast.dismiss();
        toast.error(`Couldn't get a link to verify your identity. Contact operator to resolve this issue.`);
    }
}

export const getUser = () => async dispatch => {
    const response = await API.call({
        path: '/auth/user/get',
        body: {
            uuid: await window.getFingerPrint()
        }
    });

    if(!response.success)
        return toast.error(response.error);

    dispatch({
        type: types.loaded,
        payload: {
            user: response.user,
            logins: response.logins,
            pending_voucher: response.pending_voucher ? {
                ...response.pending_voucher,
                expire_at: Date.now() + response.pending_voucher.expire_at
            } : response.pending_voucher,
            deposit_bonus: response.deposit_bonus,
            facebook: response.facebook,
            modals_list: response.modals_list,
            welcome_bonus: response.welcome_bonus,
            kyc_profile: response.kyc_profile
        }
    });

    if(response.user)
        WS.authorize(response.user.userId, response.user.userStringId);

    // if(response.user && response.user.type !== 'telegram-webapp') {
    //     // Authorize push token
    //     if(('Notification' in window) && Notification.permission === 'granted') {
    //         const token = await requestForToken();

    //         if(token)
    //             await API.call({
    //                 path: '/push/authorize',
    //                 body: {
    //                     token
    //                 }
    //             });
    //     }
    // }
}

export const activateLoadedPromocode = code => async dispatch => {
    const activation_response = await API.call({
        path: '/freecash/promocode',
        method: 'POST',
        body: {
            code
        }
    });

    if(!activation_response.success) {
        toast.dismiss();
        toast.error(activation_response.error);
    } else {
        dispatch({
            type: types.pending_voucher,
            payload: {
                ...activation_response.pending_activation,
                expire_at: Date.now() + activation_response.pending_voucher.expire_at
            }
        });

        if(activation_response.details.type === 'freeplay')
            ModalsLib.open('freeplay_add', activation_response.details);

        if(['cash', 'deposit', 'deposit-cash'].includes(activation_response.details.type)) {
            toast.dismiss();
            toast.success(activation_response.message);

            if(['deposit', 'deposit-cash'].includes(activation_response.details.type)) {
                dispatch({
                    type: globalTypes.wallet.preset,
                    payload: {
                        mode: 'tabs',
                        tab: 'deposit'
                    }
                });
                
                ModalsLib.open('wallet');
            }
        }
    }
}

export const getTelegramUser = query => async dispatch => {
    const response = await API.call({
        path: '/auth/user/telegram',
        body: {
            query,
            uuid: await window.getFingerPrint()
        }
    });

    if(!response.success)
        return toast.error(response.error);

    const userResponse = await API.call({
        path: '/auth/user/get'
    });

    if(!userResponse.success)
        return toast.error(userResponse.error);

    if(userResponse.user)
        WS.authorize(userResponse.user.userId, userResponse.user.userStringId);

    dispatch({
        type: types.loaded,
        payload: {
            user: userResponse.user,
            logins: userResponse.logins,
            pending_voucher: userResponse.pending_voucher ? {
                ...userResponse.pending_voucher,
                expire_at: Date.now() + userResponse.pending_voucher.expire_at
            } : userResponse.pending_voucher,
            deposit_bonus: userResponse.deposit_bonus,
            facebook: userResponse.facebook,
            modals_list: userResponse.modals_list,
            welcome_bonus: userResponse.welcome_bonus,
            kyc_profile: userResponse.kyc_profile
        }
    });
}

export const logout = () => async dispatch => {
    const response = await API.call({
        path: '/auth/user/logout',
    });

    if(response.success) {
        dispatch({
            type: types.logout
        });

        WS.logout();
    }
}